var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_1_",
    "data-name": "calendar (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.99,
    height: 33.99,
    viewBox: "0 0 33.99 33.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6855",
    "data-name": "Group 6855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6854",
    "data-name": "Group 6854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15173",
    "data-name": "Path 15173",
    d: "M30.348,3.642H26.707V1.214a1.214,1.214,0,1,0-2.428,0V3.642H9.711V1.214a1.214,1.214,0,1,0-2.428,0V3.642H3.642A3.642,3.642,0,0,0,0,7.284V30.348A3.642,3.642,0,0,0,3.642,33.99H30.348a3.642,3.642,0,0,0,3.642-3.642V7.284A3.642,3.642,0,0,0,30.348,3.642Zm1.214,26.707a1.214,1.214,0,0,1-1.214,1.214H3.642a1.214,1.214,0,0,1-1.214-1.214V14.567H31.562Zm0-18.209H2.428V7.284A1.214,1.214,0,0,1,3.642,6.07H7.284V8.5a1.214,1.214,0,1,0,2.428,0V6.07H24.279V8.5a1.214,1.214,0,1,0,2.428,0V6.07h3.642a1.214,1.214,0,0,1,1.214,1.214v4.856Z",
    fill: "#51aabc"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857",
    transform: "translate(6.07 16.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15174",
    "data-name": "Path 15174",
    d: "M88.975,238.933H86.547a1.214,1.214,0,0,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-85.333 -238.933)",
    fill: "#51aabc"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859",
    transform: "translate(14.567 16.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15175",
    "data-name": "Path 15175",
    d: "M208.442,238.933h-2.428a1.214,1.214,0,0,0,0,2.428h2.428a1.214,1.214,0,0,0,0-2.428Z",
    transform: "translate(-204.8 -238.933)",
    fill: "#51aabc"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861",
    transform: "translate(23.065 16.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15176",
    "data-name": "Path 15176",
    d: "M327.909,238.933h-2.428a1.214,1.214,0,0,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-324.267 -238.933)",
    fill: "#51aabc"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863",
    transform: "translate(6.07 21.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15177",
    "data-name": "Path 15177",
    d: "M88.975,307.2H86.547a1.214,1.214,0,1,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-85.333 -307.2)",
    fill: "#51aabc"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865",
    transform: "translate(14.567 21.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15178",
    "data-name": "Path 15178",
    d: "M208.442,307.2h-2.428a1.214,1.214,0,1,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-204.8 -307.2)",
    fill: "#51aabc"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867",
    transform: "translate(23.065 21.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15179",
    "data-name": "Path 15179",
    d: "M327.909,307.2h-2.428a1.214,1.214,0,1,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-324.267 -307.2)",
    fill: "#51aabc"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869",
    transform: "translate(6.07 26.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15180",
    "data-name": "Path 15180",
    d: "M88.975,375.467H86.547a1.214,1.214,0,1,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-85.333 -375.467)",
    fill: "#51aabc"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871",
    transform: "translate(14.567 26.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15181",
    "data-name": "Path 15181",
    d: "M208.442,375.467h-2.428a1.214,1.214,0,1,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-204.8 -375.467)",
    fill: "#51aabc"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873",
    transform: "translate(23.065 26.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15182",
    "data-name": "Path 15182",
    d: "M327.909,375.467h-2.428a1.214,1.214,0,1,0,0,2.428h2.428a1.214,1.214,0,1,0,0-2.428Z",
    transform: "translate(-324.267 -375.467)",
    fill: "#51aabc"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.25f19091.svg";
export { ForwardRef as ReactComponent };